<template>
  <div class="el-badge item">
    <el-button style="width:98%" @click="click(alertType)" type="button">
      {{ title }}
    </el-button>
    <sup class="el-badge__content el-badge__content is-fixed"
      :style="{ 'background-color': alertType,'margin-right': '20px'}">{{
      count }}</sup>
  </div>
</template>

<script>
import { Badge, Button } from "element-ui";
export default {
  components: {
    [Button.name]: Button,
    [Badge.name]: Badge,
  },

  props: {
    id: Number,
    count: Number,
    title: String,
    alertType: String,
    data: Array,
  },
  methods: {
    click(val) {
      this.$emit("click", this.id);
    },
    close() {
      this.$emit("close", null);
    },
  },
};
</script>

<style >
.item {
  margin-top: 10px;
  margin-right: 40px;
  width: 100%;
}
</style>